const faqData1 = [
  {
    uuid: 'a',
    question: 'Why Choose Us?',
    answer:
      'Our Mission is to Build products and solutions that simplifies complex business process, improves lives of our users and help people, businesses, and institutions achieve economic & social progress.',
  },
  {
    uuid: 'b',
    question: 'What is a Data Analysis?',
    answer:
      'Data analysis is an important function. Data analysts looks at historical data, identify trends, generates insists, translate into meaningful reports/dashboards. This helps business identify gaps in process and takes key strategic decisions.',
  },
  {
    uuid: 'c',
    question: 'What is IT Consulting Services?',
    answer:
      'IT consulting services are advisory services that help clients assess different technology strategies and, in doing so, align their technology strategies with their business or process strategies.',
  },
  {
    uuid: 'd',
    question: 'What is a Infrastructure?',
    answer:
      'Infrastructure is the foundation or framework that supports a system or organization. In computing, information technology infrastructure is composed of physical and virtual resources that support the flow, storage, processing and analysis of data.',
  },
]

const faqData2 = [
  {
    uuid: 'a',
    question: 'How Can We Help Your Business?',
    answer:
      'InnoAge is committed to provide innovative IT solutions and high-quality operations services to businesses. InnoAge helps business to focus on their business development by taking care of their IT and operations services.',
  },
  {
    uuid: 'b',
    question: 'What is IT Consulting Services?',
    answer:
      'IT consulting services are advisory services that help clients assess different technology strategies and, in doing so, align their technology strategies with their business or process strategies.',
  },
  {
    uuid: 'c',
    question: 'What is InnoSales?',
    answer:
      'InnoSales is a platform where you can create a Professional-looking product catalogue and showcase your product digitally on global scale, track buyer activities & communicate seamlessly.',
  },
  {
    uuid: 'd',
    question: 'Is InnoSales Free?',
    answer:
      'If you are a small business who wants to have digital presence of your products, we will bear all the cost for the platform use. This is our small effort to give back to the society.',
  },
]

const faqis1 = [
  {
    uuid: 'a',
    question: 'What is InnoSales?',
    answer:
      'InnoSales is a platform where you can create a Professional-looking product catalogue and showcase your product digitally on global scale, track buyer activities & communicate seamlessly.',
  },
  {
    uuid: 'b',
    question: 'Why Choose Us?',
    answer:
      'Our Mission is to Build products and solutions that simplifies complex business process, improves lives of our users and help people, businesses, and institutions achieve economic & social progress',
  },
  {
    uuid: 'c',
    question: 'Is InnoSales Free?',
    answer:
      'InnoSales works on SaaS subscription model that means you pay for what you use. But, If you are a small business who wants to have digital presence of your products, we will bear all the cost for the platform use. This is our small effort to give back to the society.',
  },
  {
    uuid: 'd',
    question: 'What is Included in Free Trial?',
    answer: 'Free Trial will include all the Features of the Subscription Plan you choose',
  },
]

const faqis2 = [
  {
    uuid: 'a',
    question: 'Which Subscription Plan Should I choose?',
    answer:
      'Our Subscription plan targets everyone who wants to sell there products onshore or offshore. Depending on customer needs we have created different 4 Pricing Plans. Choose the One that meets your goals. by refering to our Pricing Section or you may choose to Contact us',
  },
  {
    uuid: 'b',
    question: 'How My Product Images are stored?',
    answer:
      'All your Product Images are stored on our cloud container. Only you & the people you authorise will be able to view the images.',
  },
  {
    uuid: 'c',
    question: 'How do I Subscribe to InnoSales?',
    answer:
      'Signup by clicking on the Right corner button & we will reach out to you for next steps.',
  },
  {
    uuid: 'd',
    question: 'Which Languages InnoSales support?',
    answer:
      'As English is the most widely spoken language worldwide, with 1.5 billion speakers. So we started with English but we have plans to rollout support to हिन्दी (Hindi), اردو (Urdu), বাংলা (Bangla) & many more',
  },
]

const whyInnosales = {
  helpText: 'Share your Products globally',
  title: 'Share, Promote & Distribute',
  shortDesc1:
    'With our cloud based, highly responsive features and dedicated team of experts you’ve got one big thing off of your mind.',
  shortDesc2:
    'Unlike similar market options, your company will integrate fast, setting up a better business environment sooner than you’d expect.',
  experienceList1: [
    {
      id: 1,
      title: 'Onboard Products in 2 Clicks',
    },
    {
      id: 2,
      title: 'Catalogue in 5 Minutes',
    },
  ],
  experienceList2: [
    {
      id: 3,
      title: 'Secured Cloud Storage',
    },
    {
      id: 4,
      title: 'Real time Activity Tracking',
    },
  ],
  subText: 'Share, Promote & Distribute',
  headerText: 'InnoSales ',
  experimg: {
    url: 'https://res.cloudinary.com/innoage/image/upload/v1653579168/innosales_71a1d7a6bd.png',
  },
  url: 'https://www.youtube.com/watch?v=_8nAG4dX10Y&t',
}

const whyTMS = {
  helpText: 'Ship your Products globally',
  title: 'Streamline, Simplify & Succeed',
  shortDesc1: 'Simplify Global Shipping: One Platform, Multiple Carriers, Endless Possibilities',
  shortDesc2:
    'Unlike similar market options, your company will integrate fast, setting up a better business environment sooner than you’d expect.',
  experienceList1: [
    {
      id: 1,
      title: 'Multi-Carrier Support',
    },
    {
      id: 2,
      title: 'Shipping Management',
    },
  ],
  experienceList2: [
    {
      id: 3,
      title: 'Analytics and Reporting',
    },
    {
      id: 4,
      title: 'Label Printing',
    },
  ],
  subText: 'Share, Promote & Distribute',
  headerText: 'InnoSales ',
  experimg: {
    url: 'https://res.cloudinary.com/innoage/image/upload/v1653579168/innosales_71a1d7a6bd.png',
  },
  urlAlt:
    'https://res.cloudinary.com/innoage/image/upload/c_scale,h_551,w_1099/v1684601233/tms2_cnzidj.png',
}

const faqtms1 = [
  {
    uuid: 'a',
    question: 'What is TMS software, and how can it benefit my business?',
    answer:
      'TMS software, or Transportation Management System software, helps businesses efficiently manage their transportation operations. It optimizes routes, automates processes, enhances visibility, and reduces costs, resulting in improved operational efficiency and customer satisfaction',
  },
  {
    uuid: 'b',
    question: 'How does your TMS software help in optimizing transportation operations?',
    answer:
      'Our TMS software offers robust features such as route optimization, load consolidation, carrier management, and real-time tracking. It streamlines the entire transportation workflow, reduces manual tasks, eliminates inefficiencies, and improves resource utilization',
  },
  {
    uuid: 'c',
    question: 'Can your TMS software integrate with our existing systems and carriers?',
    answer:
      'Yes, our TMS software is designed to seamlessly integrate with various systems and carriers. We offer flexible integration options, including API-based integrations, EDI, and web services, ensuring smooth data exchange and collaboration across your transportation network.',
  },
  {
    uuid: 'd',
    question: 'Is your TMS software scalable to accommodate our growing business needs?',
    answer:
      'Absolutely! Our TMS software is built to scale alongside your business. It can handle increased shipment volumes, support multiple locations, and adapt to evolving industry demands. You can confidently rely on our TMS to grow with your business',
  },
  {
    uuid: 'e',
    question:
      'What features does your TMS software offer for shipment tracking and real-time visibility?',
    answer:
      'Our TMS software provides comprehensive shipment tracking and real-time visibility. You can monitor shipments, track their progress, receive alerts, and access detailed status updates at any point during the transportation process. This ensures transparency and enables proactive decision-making',
  },
]

const faqtms2 = [
  {
    uuid: 'a',
    question:
      'Does your TMS software provide analytics and reporting capabilities for performance monitoring?',
    answer:
      'Yes, our TMS software includes robust analytics and reporting features. You can generate customized reports, analyze key performance indicators, identify trends, and gain valuable insights into your transportation operations. This data-driven approach helps optimize performance and drive continuous improvement',
  },
  {
    uuid: 'b',
    question:
      'How secure is the data within your TMS software, especially regarding sensitive shipment information?',
    answer:
      'Data security is a top priority for us. Our TMS software employs industry-standard security protocols and encryption techniques to safeguard your data. We have stringent access controls, regular backups, and adhere to strict data protection regulations to ensure the highest level of security',
  },
  {
    uuid: 'c',
    question:
      'What level of customer support and training can we expect when implementing your TMS software?',
    answer:
      'We pride ourselves on providing exceptional customer support and training. Our dedicated support team is available to assist you throughout the implementation process and beyond. We offer comprehensive training programs, user documentation, and ongoing assistance to ensure a smooth and successful TMS implementation.',
  },
  {
    uuid: 'd',
    question: 'Can your TMS software automate freight rate management and carrier selection?',
    answer:
      'Yes, our TMS software offers advanced functionality for freight rate management and carrier selection. It automates rate comparison, enables rate negotiation, and helps you select the most cost-effective carrier based on predefined criteria. This optimizes freight spend and enhances carrier relationship management.',
  },
  {
    uuid: 'e',
    question: 'What are the pricing plans for your TMS software?',
    answer:
      'We understand that every business has unique transportation needs, and pricing can vary based on specific requirements. To provide you with the best solution tailored to your needs, we invite you to contact us. Our dedicated sales manager will get in touch with you to understand your requirements in detail. Based on your specific needs and the features you require, we will offer you a customized solution along with a pricing plan that aligns with your budget and business goals. We are committed to providing transparent and flexible pricing options to ensure you get the most value out of our TMS software.',
  },
]

const faqir1 = [
  {
    uuid: 'a',
    question: 'What is InnoRug?',
    answer:
      'InnoRug is a comprehensive ERP software designed specifically for the rug manufacturing industry, aimed at streamlining processes and enhancing productivity.',
  },
  {
    uuid: 'b',
    question: 'What modules are included in InnoRug?',
    answer:
      'InnoRug includes modules for inventory management, bill of materials, product development, weaving process management, shipment management, packaging management, and more.',
  },
  {
    uuid: 'c',
    question: 'Is InnoRug suitable for small businesses?',
    answer:
      'Yes, InnoRug offers scalable solutions suitable for both small businesses and large enterprises.',
  },
  {
    uuid: 'd',
    question: 'Can InnoRug integrate with other software systems we use?',
    answer:
      'Yes, InnoRug is designed to integrate seamlessly with other software systems to ensure data consistency and ease of use.',
  },
  {
    uuid: 'e',
    question: 'Does InnoRug offer real-time activity tracking?',
    answer:
      'Yes, InnoRug provides real-time activity tracking, allowing you to monitor and optimize your rug manufacturing processes',
  },
]

const faqir2 = [
  {
    uuid: 'a',
    question: 'Is InnoRug cloud-based or on-premises?',
    answer:
      'InnoRug is available both as a cloud-based solution for convenience and as an on-premises option for businesses with specific security requirements.',
  },
  {
    uuid: 'b',
    question: 'How user-friendly is InnoRug?',
    answer:
      'InnoRug offers an intuitive user interface, making it easy for your team to quickly adopt and use the software effectively.',
  },
  {
    uuid: 'c',
    question: 'Can InnoRug connect with sensors and IoT devices?',
    answer:
      'Yes, InnoRug is capable of connecting with sensors and IoT devices, allowing you to gather valuable data for enhanced decision-making.',
  },
  {
    uuid: 'd',
    question: ' What kind of customer support does InnoRug provide?',
    answer:
      'InnoRug offers customer support, including standard support during business hours and premium 24/7/365 support for enterprise users.',
  },
  {
    uuid: 'e',
    question: 'How can I get started with InnoRug for my rug manufacturing business?',
    answer:
      'You can get started with InnoRug by contacting our sales team. We will guide you through the process of selecting the right plan and onboarding your business for success.',
  },
]

const whyPOM = {
  helpText: 'Your All-in-One Solution',
  title: 'Simplify, Streamline, Succeed',
  shortDesc1:
    'With our cloud based, highly responsive features and dedicated team of experts you’ve got one big thing off of your mind.',
  shortDesc2:
    'Unlike similar market options, your company will integrate fast, setting up a better business environment sooner than you’d expect.',
  experienceList1: [
    {
      id: 1,
      title: 'PO Management',
    },
    {
      id: 2,
      title: 'Vendor Management',
    },
  ],
  experienceList2: [
    {
      id: 3,
      title: 'Secured Cloud Storage',
    },
    {
      id: 4,
      title: 'Cost Negotiation',
    },
  ],
  subText: 'Simplify, Streamline, Succeed',
  headerText: 'POM',
  experimg: {
    url: 'https://res.cloudinary.com/innoage/image/upload/v1653579168/innosales_71a1d7a6bd.png',
  },
  url: 'https://www.youtube.com/watch?v=vFk2cZioaTI',
}

const faqpom1 = [
  {
    uuid: 'a',
    question: 'What is POM and how can it benefit my business?',
    answer:
      'POM, or Purchase Order Management, is a SaaS tool that helps businesses streamline and automate their purchasing processes. It offers features such as creating and managing purchase orders, vendor management, budget tracking, and more. It can benefit your business by improving efficiency, reducing errors, and enhancing collaboration with vendors',
  },
  {
    uuid: 'b',
    question: 'Is POM compatible with my existing systems?',
    answer:
      'Yes, POM is designed to integrate smoothly with various systems. It offers flexible integration options and supports common file formats, APIs, and data transfer protocols',
  },
  {
    uuid: 'c',
    question: 'Can I customize purchase order templates in POM?',
    answer:
      'Yes, POM provides customizable templates, allowing you to personalize the look and feel of your purchase orders to match your brand and business requirements',
  },
  {
    uuid: 'd',
    question: 'How secure is my data in POM?',
    answer:
      'Data security is a top priority for us. POM employs robust security measures, including encryption, access controls, and regular data backups, to ensure the safety and confidentiality of your information',
  },

  {
    uuid: 'e',
    question: 'Does POM support multiple currencies for international transactions?',
    answer:
      'Yes, POM supports multiple currencies, enabling you to handle purchase orders and transactions in different currencies for international operations.',
  },
]

const faqpom2 = [
  {
    uuid: 'a',
    question: 'Is POM suitable for businesses of all sizes?',
    answer:
      'POM, or Purchase Order Management, is a SaaS tool that helps businesses streamline and automate their purchasing processes. It offers features such as creating and managing purchase orders, vendor management, budget tracking, and more. It can benefit your business by improving efficiency, reducing errors, and enhancing collaboration with vendors',
  },
  {
    uuid: 'b',
    question: 'Can I track the status of my purchase orders in real-time?',
    answer:
      'Absolutely! POM provides real-time tracking of purchase orders, allowing you to monitor the progress, delivery status, and expected arrival times for each order',
  },
  {
    uuid: 'c',
    question: 'Can I import my existing vendor database into POM?',
    answer:
      'Yes, POM offers easy vendor onboarding, allowing you to import your existing vendor database seamlessly. You can also add new vendors directly within the system.',
  },
  {
    uuid: 'd',
    question: 'Can I generate reports and analytics?',
    answer:
      'Yes, POM offers comprehensive reporting and analytics capabilities. You can generate customized reports, track purchasing trends, analyze vendor performance, and gain valuable insights for informed decision-making',
  },
  {
    uuid: 'e',
    question: 'How can I get support or assistance if I have questions about POM?',
    answer:
      'Our dedicated support team is available to assist you with any questions or issues you may have. You can reach out to us via email, phone, or through our support portal for prompt assistance',
  },
]

const whyMHub = {
  helpText: 'Transforming E-commerce Experiences for Businesses and Customers',
  title: 'Simplify, Streamline, Succeed',
  shortDesc1:
    'Unlock New Business Opportunities and Seamlessly Manage E-commerce Operations with Our Comprehensive Marketplace Hub!',
  shortDesc2:
    'Unlike similar market options, your company will integrate fast, setting up a better business environment sooner than you’d expect.',
  experienceList1: [
    {
      id: 1,
      title: 'Seamless Integration',
    },
    {
      id: 2,
      title: 'Inventory Management',
    },
  ],
  experienceList2: [
    {
      id: 3,
      title: 'Warehouse Integration',
    },
    {
      id: 4,
      title: 'Pricing and Offer Management',
    },
  ],
  subText: 'Simplify, Streamline, Succeed',
  headerText: 'POM',
  experimg: {
    url: 'https://res.cloudinary.com/innoage/image/upload/v1653579168/innosales_71a1d7a6bd.png',
  },
  urlAlt:
    'https://res.cloudinary.com/innoage/image/upload/c_scale,w_1024/v1684656978/Ecommerce_teupuu.png',
  utlAltHeight: '60vh',
}

const faqmhub1 = [
  {
    uuid: 'a',
    question:
      'How does the Marketplace Hub help me expand my business across different e-commerce platforms?',
    answer:
      'The Marketplace Hub allows you to seamlessly connect with major e-commerce platforms, expanding your reach and customer base',
  },
  {
    uuid: 'b',
    question: 'Can I integrate my existing online store with the Marketplace Hub?',
    answer:
      'Yes, you can easily integrate your existing online store with the Marketplace Hub, streamlining your operations.',
  },
  {
    uuid: 'c',
    question:
      'How does the Marketplace Hub handle inventory management across multiple marketplaces?',
    answer:
      'Our Marketplace Hub offers comprehensive inventory management features, ensuring accurate stock control across multiple marketplaces',
  },
  {
    uuid: 'd',
    question: 'Can I manage product pricing and promotions from a single platform?',
    answer:
      'With the Marketplace Hub, you can efficiently manage product pricing and promotions, maintaining consistent strategies across platforms',
  },

  {
    uuid: 'e',
    question: 'Does the Marketplace Hub offer real-time order management and shipment tracking?',
    answer:
      'Enjoy real-time order management and shipment tracking, keeping you informed and in control throughout the entire fulfillment process',
  },
]

const faqmhub2 = [
  {
    uuid: 'a',
    question: 'Can I customize my storefront and product listings on different marketplaces?',
    answer:
      'Customize your storefront and product listings on different marketplaces to create a cohesive and branded shopping experience for customers',
  },
  {
    uuid: 'b',
    question:
      'What types of analytics and reporting capabilities does the Marketplace Hub provide?',
    answer:
      'The Marketplace Hub provides robust analytics and reporting tools, empowering you with valuable insights to optimize your business performance',
  },
  {
    uuid: 'c',
    question:
      'Is it possible to integrate third-party warehouse management systems with the Marketplace Hub?',
    answer:
      'Our platform supports integration with third-party warehouse management systems, streamlining your warehouse operations',
  },
  {
    uuid: 'd',
    question:
      'How does the Marketplace Hub handle product synchronization and updates across marketplaces?',
    answer:
      'The Marketplace Hub ensures seamless product synchronization and updates across all integrated marketplaces, minimizing errors and discrepancies',
  },

  {
    uuid: 'e',
    question:
      'What level of support and training is available for using the Marketplace Hub effectively?',
    answer:
      'We offer comprehensive support and training resources to help you maximize the benefits of the Marketplace Hub, ensuring your success in the e-commerce landscape',
  },
]

const whyInnorug = {
  helpText: 'Enhance Your Rug Manufacturing',
  title: 'Crafting Excellence, One Rug at a Time',
  shortDesc1:
    'With our cloud based, highly responsive features and dedicated team of experts you’ve got one big thing off of your mind.',
  shortDesc2:
    'Unlike similar market options, your company will integrate fast, setting up a better business environment sooner than you’d expect.',
  experienceList1: [
    {
      id: 1,
      title: 'Inventory Management',
    },
    {
      id: 2,
      title: 'IOT Integration',
    },
  ],
  experienceList2: [
    {
      id: 3,
      title: 'Secured Cloud Storage',
    },
    {
      id: 4,
      title: 'Data Analytics and Reporting',
    },
  ],
  subText: 'Share, Promote & Distribute',
  headerText: 'InnoRug ',
  experimg: {
    url: 'https://res.cloudinary.com/innoage/image/upload/v1697440720/innorug-sample_ovxxf5.png',
  },
  urlAlt: 'https://res.cloudinary.com/innoage/image/upload/v1697440720/innorug-sample_ovxxf5.png',
}

const innosalesPricing = {
  title: 'Create, Share & ',
  grids: [
    {
      id: 1,
      name: 'Freemium',
      price: '₹ 0',
      priceUnit: '/per year',
      description: 'Most Sutable for Startups that want digital Product Inventory',
      features: [
        'Free Forever for Startups',
        '1 User',
        '100 SKU',
        '1000 Pictures',
        '1 GB Space',
        'Company Shop',
        'Access to Help Portal',
      ],
    },
    {
      id: 2,
      name: 'Premium',
      price: '₹ 24999',
      priceUnit: '/per year',
      description: 'For Companies that want to Start Export Business with Digital Presence',
      features: [
        '3 Users',
        '500 SKUs',
        '5000 Pictures',
        '20 GB Space',
        'Company Shop',
        'Catalogue Generator',
        'PIS/PPT Downloads',
        '50 Catalogues',
        'Chat Box',
        'Access to Help Portal',
        '3 Day Training',
        'Onboarding Support & Demo',
      ],
    },
    {
      id: 3,
      name: 'Elite',
      price: '₹ 39999',
      priceUnit: '/per year',
      description: 'For Companies already in Export Business & want to grow further',
      features: [
        '7 Users',
        '2000 SKUs',
        '100000 Pictures',
        '100 GB Space',
        'Company Shop',
        'Dashboard',
        '1000 Catalogues',
        'Catalogue Generator',
        'Activity Tracker',
        'PIS/PPT Downloads',
        'Advance Image Editor',
        'Chat Box',
        'Access to Help Portal',
        '1 Week Training',
        'Live Onboarding & Demo',
        'Priority Support',
        'Branding Support',
      ],
    },
    {
      id: 4,
      name: 'Enterprise',
      price: 'Custom',
      priceUnit: ' (Tailored pricing)',
      description: 'For Large Enterprises that want to have everything on single Platform',
      isRecommended: true,
      features: [
        'Unlimited Users',
        'Unlimited SKUs',
        'Unlimited Pictures',
        '150 GB + Expansion Available',
        'Company Shop',
        'Dashboard',
        'Chat Box',
        'Quotation',
        'Unlimited Catalogues',
        'Catalogue Generator',
        'Activity Tracker',
        'PIS/PPT Downloads',
        'Advance Image Editor',
        'Bulk Import Products',
        'Bulk Edit Products',
        'Access to Help Portal',
        '1 Month Training',
        'Live Onboarding & Demo',
        'Priority Support',
        'Branding Support',
        'Access to Upcoming Features',
      ],
    },
  ],
}

const innorugPricing = {
  title: 'Get Started with InnoRug',
  subtitle: 'Choose the Right Plan for Your Rug Manufacturing Needs',
  grids: [
    {
      id: 1,
      name: 'Basic',
      price: '₹ 24999',
      priceUnit: '/per year',
      description: 'Enhanced Solutions for Growing Enterprises',
      features: [
        'Single User Account',
        'Product Management',
        'Basic Sales',
        'Standard Manufacturing',
        'Bill of Materials',
        'Standard Invoicing',
        'Standard Inventory Management',
        'Real-time Activity Tracking',
        'Standard Support',
      ],
    },
    {
      id: 2,
      name: 'Pro',
      price: '₹ 39999',
      priceUnit: '/per year',
      description: 'Top-Tier Features for Premium Performance',
      features: [
        'Everything in the Basic Plan',
        'Advance Sales ',
        'Advanced Inventory',
        'Shipment Management',
        'Work Orders Management',
        'Employee and HR Management',
        'User Level Security',
        'Weaving Process Management',
        'Barcode Management',
        'Loom Inspection for Subcontractors',
        'Bazaar and Quality Management',
        'Finishing Job Work Management',
        'Product Receiving and QC',
        'Multi-Currency Invoicing',
        'Priority Support',
      ],
    },
    {
      id: 3,
      name: 'Enterprise',
      price: 'Custom',
      priceUnit: ' (Tailored pricing)',
      description: 'Enterprise Solutions for Industry Leaders',
      isRecommended: true,
      features: [
        'Everything in the Pro Plan',
        'Research and Development',
        'Advanced Weaving Process Management',
        'Inter-Location Carpet Transfer',
        'Product Packaging',
        'Dedicated Account Manager',
        'Accounting Management',
        'Digital Gate Pass Management',
        'Internal Employee Communication',
        'Real-time Email Notifications',
        'WhatsApp Integration',
        'Advanced Customization',
        'Sensor and IoT Integration',
        'New Features & Upgrade Support',
        '',
        '24/7/365 Premium Support',
      ],
    },
  ],
}

const Data = {
  faqData1,
  faqData2,
  faqis1,
  faqis2,
  whyInnosales,
  whyTMS,
  faqtms1,
  faqtms2,
  whyPOM,
  faqpom1,
  faqpom2,
  whyMHub,
  faqmhub1,
  faqmhub2,
  whyInnorug,
  faqir1,
  faqir2,
  innosalesPricing,
  innorugPricing,
}

export default Data
